import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Подписывается на канал обработки АМ. Прогресс (files_done) обновляется в DOM
// на каждом сообщении по вебсокету; при смене статуса — перезагрузка страницы,
// чтобы перерисовать статусы файлов, кнопки и итоговое состояние.
export default class extends Controller {
  static values = { id: Number, state: String }
  static targets = ["currentFile", "progress", "progressBar"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "Am::ProcessingChannel", am_processing_id: this.idValue },
      { received: (data) => this.handleMessage(data) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(data) {
    if (data.type === "progress") {
      if (data.state !== this.stateValue) {
        window.location.reload()
        return
      }
      this.updateProgress(data)
    }
    if (data.type === "error" && window.Toast) {
      window.Toast.error(data.error)
    }
  }

  updateProgress(data) {
    const done = data.files_done ?? 0
    const total = data.total_files ?? 0

    if (this.hasProgressTarget) {
      this.progressTarget.textContent = `${done} / ${total}`
    }
    if (this.hasProgressBarTarget) {
      const pct = total > 0 ? Math.round((done / total) * 100) : 0
      this.progressBarTarget.style.width = `${pct}%`
    }
    if (this.hasCurrentFileTarget) {
      this.currentFileTarget.textContent = data.current_file ?? ""
    }
  }
}
